import {
  SR_STRIPE_CARD_EXPIRED_CARD,
  SR_STRIPE_CARD_INCORRECT_CVC,
  SR_STRIPE_CARD_INCORRECT_NUMBER,
  SR_STRIPE_CARD_INVALID_CVC,
} from 'common/errorCodes';

export const STRIPE_CHARGE_CATEGORY_SUNROOM_SELECT = 'SunroomSelect';
export const STRIPE_CHARGE_CATEGORY_APPLICATION_FEE = 'ApplicationFee';
export const STRIPE_CHARGE_CATEGORY_GUARANTOR_APPLICATION_FEE = 'GuarantorApplicationFee';
export const STRIPE_CHARGE_CATEGORY_SECURITY_DEPOSIT = 'SecurityDeposit';

export const STRIPE_OBJECT_TYPE_SOURCE = 'source';
export const STRIPE_OBJECT_TYPE_TOKEN = 'token';
export const STRIPE_OBJECT_TYPE_CARD = 'card';
export const STRIPE_OBJECT_TYPE_BANK_ACCOUNT = 'bank_account';

export const STRIPE_ACCOUNT_TYPE_CARD = 'CreditDebitCard';

export const STRIPE_FEE_PERCENTAGE_BANK = 0.01;
export const STRIPE_FEE_PERCENTAGE_CARD = 0.03;

export const STRIPE_CHARGE_CUTOFF_DAYS_APPLICATION_FEE = 60;

export const STRIPE_SOURCE_TYPE_CARD = 'card';
export const STRIPE_SOURCE_TYPE_ACH_DEBIT = 'ach_debit';

export const STRIPE_CHARGE_STATUS_PENDING = 'pending';
export const STRIPE_CHARGE_STATUS_SUCCESS = 'success';
export const STRIPE_CHARGE_STATUS_FAILED = 'failed';

export const STRIPE_PAYMENT_ACCOUNT_STATUS_NEW = 'new';
export const STRIPE_PAYMENT_ACCOUNT_STATUS_VERIFICATION_FAILED = 'verification_failed';
export const STRIPE_PAYMENT_ACCOUNT_STATUS_ERRORED = 'errored';

export const STRIPE_PAYOUT_STATUS_PENDING = 'pending';
export const STRIPE_PAYOUT_STATUS_IN_TRANSIT = 'in_transit';
export const STRIPE_PAYOUT_STATUS_PAID = 'paid';
export const STRIPE_PAYOUT_STATUS_CANCELED = 'canceled';
export const STRIPE_PAYOUT_STATUS_FAILED = 'failed';

export const CHARGE_TYPE_OFFLINE = 'Offline';
export const CHARGE_TYPE_ONLINE = 'Online';

export const STRIPE_ERROR_CODE_CARD_DECLINED = 'card_declined';
export const STRIPE_ERROR_CODE_CARD_INVALID_TYPE = 'invalid_card_type';
export const STRIPE_CARD_ERROR_CODE_INSUFFICIENT_FUNDS = 'insufficient_funds';
export const STRIPE_CARD_ERROR_CODE_GENERIC_DECLINE = 'generic_decline';

export const STRIPE_CARD_ERROR_CODE_INCORRECT_NUMBER = 'incorrect_number';
export const STRIPE_CARD_ERROR_CODE_INCORRECT_CVC = 'incorrect_cvc';
export const STRIPE_CARD_ERROR_CODE_INVALID_CVC = 'invalid_cvc';
export const STRIPE_CARD_ERROR_CODE_EXPIRED_CARD = 'expired_card';

export const STRIPE_CARD_ERROR_MESSAGE_INCORRECT_DATA =
  "Sorry, the card is not valid. Please double check your card's information. ";

export const STRIPE_CARD_ERROR_MESSAGE_INSUFFICIENT_FUNDS =
  'Your payment method was declined for insufficient funds.';
export const STRIPE_CARD_ERROR_MESSAGE_GENERIC_DECLINE =
  'Sorry, the card was declined. Please try another card.';

export const STRIPE_CARD_ERROR_MESSAGE_EXPIRED_CARD =
  'Sorry, the card has expired. Please try another card.';

export const STRIPE_CARD_DECLINED_ERROR_MAPPING = {
  [STRIPE_CARD_ERROR_CODE_GENERIC_DECLINE]: STRIPE_CARD_ERROR_MESSAGE_GENERIC_DECLINE,
  [STRIPE_CARD_ERROR_CODE_INSUFFICIENT_FUNDS]: STRIPE_CARD_ERROR_MESSAGE_INSUFFICIENT_FUNDS,
};

export const STRIPE_CARD_CODE_ERROR_MAPPING = {
  [STRIPE_CARD_ERROR_CODE_INCORRECT_NUMBER]: {
    name: SR_STRIPE_CARD_INCORRECT_NUMBER,
    message: STRIPE_CARD_ERROR_MESSAGE_INCORRECT_DATA,
  },
  [STRIPE_CARD_ERROR_CODE_INCORRECT_CVC]: {
    name: SR_STRIPE_CARD_INCORRECT_CVC,
    message: STRIPE_CARD_ERROR_MESSAGE_INCORRECT_DATA,
  },
  [STRIPE_CARD_ERROR_CODE_INVALID_CVC]: {
    name: SR_STRIPE_CARD_INVALID_CVC,
    message: STRIPE_CARD_ERROR_MESSAGE_INCORRECT_DATA,
  },
  [STRIPE_CARD_ERROR_CODE_EXPIRED_CARD]: {
    name: SR_STRIPE_CARD_EXPIRED_CARD,
    message: STRIPE_CARD_ERROR_MESSAGE_EXPIRED_CARD,
  },
};

export const STRIPE_ERROR_CODES_HANDLED = [
  STRIPE_ERROR_CODE_CARD_DECLINED,
  STRIPE_ERROR_CODE_CARD_INVALID_TYPE,
  STRIPE_CARD_ERROR_CODE_INCORRECT_NUMBER,
  STRIPE_CARD_ERROR_CODE_INCORRECT_CVC,
  STRIPE_CARD_ERROR_CODE_INVALID_CVC,
  STRIPE_CARD_ERROR_CODE_EXPIRED_CARD,
];
